export const USER_PROMO_CODE_ACTION = {
  SET_USER_PROMO_CODES: 'userPromoCodeService/SET_USER_PROMO_CODES',
  CALLED_USER_PROMO_CODES_FETCHING: 'userPromoCodeService/CALLED_USER_PROMO_CODES_FETCHING',
};
